import { forwardRef } from 'react'
import { Dialog, Slide, Box, Typography} from "@mui/material";
import { useStyles } from './SiteInMaintenancePopup.styles';
import PcAndIconsImg from '../../assets/siteInMaintencePopupImagen.png'
import VillanuevaIcon from '../../assets/logo_VN_blanco.png'
import backgroundConnectionsImg from '../../assets/connectionsPopupBackground.png'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function SiteInMaintenancePopUp ({ isOpen = false, onClose }) {
  const styles = useStyles()

  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      TransitionComponent={Transition}
    >
      <Box className={styles.container}>
        <img src={backgroundConnectionsImg} className={styles.backgroundImg}/>
        <Box className={styles.bandContainer}>
          <Box className={styles.text1Container}>
            <Typography style={{fontSize: 14}} className={styles.whiteText}>
              <i>
                Estamos realizando tareas de mantenimiento
              </i>
            </Typography>
          </Box>
        </Box>
        <Box className={styles.centerContainer}>
          <Box className={styles.whiteBackgroundContainer}>
            <Box className={styles.text1}>
              <Typography style={{fontWeight: '500'}}  className={styles.whiteText}>
                ¡Muy pronto estaremos de vuelta!
              </Typography>
            </Box>
            <Typography sx={{fontSize: 14}}>
              Lamentamos los inconvenientes que esto puede causarte. Mientras tanto, 
              <span style={{fontSize: 14}} className={styles.redText}> podés seguir contactándote con tu asesor comercial, </span>
               sucursal o nuestros demás canales de contacto. 
              <Typography sx={{fontSize: 14, fontWeight: 'bold'}} className={styles.redText}>¡Muchas gracias!</Typography>
            </Typography>
          </Box>
        </Box>
        <Box style={{marginBottom: 0}} className={styles.centerContainer}>
          <img width="300px" src={PcAndIconsImg}/>
        </Box>
        <Box className={styles.villanuevaIconFooterContainer}>
          <img src={VillanuevaIcon} />
        </Box>
      </Box>
    </Dialog>
  )
}